import { TrendingUp, Truck, Wallet } from "lucide-react";

const HomeChefArchitectureOfGrowth = () => {
  const items = [
    {
      icon: <TrendingUp size={32} strokeWidth={1.5} />,
      title: "Scale Fast",
      desc: "Use our infrastructure to expand your reach without needing a physical restaurant storefront.",
    },
    {
      icon: <Truck size={32} strokeWidth={1.5} />,
      title: "Simplify Operations",
      desc: "We automate the boring stuff (billing, tracking, support) so you can stay at the stove.",
    },
    {
      icon: <Wallet size={32} strokeWidth={1.5} />,
      title: "Maximize Revenue",
      desc: "Lower overheads and higher ticket prices for authentic, artisanal home food.",
    },
  ];

  return (
    <section className="hc-section hc-section-alt">
      <div className="container text-center">
        <span className="hc-section-overline">elite advantages</span>
        <h2 className="hc-section-title">The Architecture of Growth</h2>
        <div className="row mt-5">
          {items.map((item, i) => (
            <div className="col-md-4" key={i}>
              <div className="hc-arch-icon">{item.icon}</div>
              <h5>{item.title}</h5>
              <p className="hc-muted">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeChefArchitectureOfGrowth;
